import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IPortalLink } from '@nha/api/core/types/portal-link.type';
import { isEmpty } from '@nha/functions';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PortalLinkState } from './portal-link.state';
import * as fromActions from './portal-link.actions';
import * as fromSelectors from './portal-link.selectors';
import { Dictionary } from '@ngrx/entity';

@Injectable()
export class PortalLinkFacade {
	private store$ = inject<Store<PortalLinkState>>(Store);

	isLoaded$: Observable<boolean> = this.store$.pipe(select(fromSelectors.selectIsLoaded));
	isLoading$: Observable<boolean> = this.store$.pipe(select(fromSelectors.selectIsLoading));
	allActivePortalLinks$: Observable<IPortalLink[]> = this.store$.pipe(select(fromSelectors.selectAllEnabledPortalLinks));
	allPortalLinks$: Observable<IPortalLink[]> = this.store$.pipe(select(fromSelectors.selectAll));
	selectFavorites$: Observable<IPortalLink[]> = this.store$.pipe(select(fromSelectors.selectFavorites));
	selectQuickLinks$: Observable<IPortalLink[]> = this.store$.pipe(select(fromSelectors.selectQuickLinks));
	selectEntities$: Observable<Dictionary<IPortalLink>> = this.store$.pipe(select(fromSelectors.selectEntities));

	filteredLinkList$ = (searchText: string): Observable<IPortalLink[]> =>
		this.allActivePortalLinks$.pipe(
			map((portalLinks) => {
				return filterPortalLinks(portalLinks, searchText);
			})
		);

	loadPortalLinks(): void {
		this.store$.dispatch(fromActions.LoadPortalLinks());
	}

	setFavorite(portalLinkID: number, isFavorite: boolean): void {
		this.store$.dispatch(fromActions.SetFavorite({ portalLinkID, isFavorite }));
	}

	updateFavoritesOrder(portalLinks: IPortalLink[]): void {
		this.store$.dispatch(fromActions.updateFavoritesOrder({ portalLinks }));
	}

	updateQuickLinksOrder(portalLinks: IPortalLink[]): void {
		this.store$.dispatch(fromActions.updateQuickLinksOrder({ portalLinks }));
	}
}

export const filterPortalLinks = (portalLinks: IPortalLink[], searchText: string): IPortalLink[] => {
	if (isEmpty(searchText)) {
		return portalLinks;
	}
	const lowerCaseSearchTerm = searchText.toLowerCase();
	return portalLinks.filter(
		(x) =>
			x.portalLinkName.toLowerCase().includes(lowerCaseSearchTerm) ||
			(x.description !== null && x.description.toLowerCase().includes(lowerCaseSearchTerm)) ||
			x.linkUrl.toLowerCase().includes(lowerCaseSearchTerm)
	);
};
